import { Box, Button, Grid, Paper } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { Add } from '@mui/icons-material';
import { DocumentCategorySearchFilter } from '../models/documentCategorySearchFilter';
import { DocumentCategoryHandler } from '../components/documentCategoryHandler';
import { DocumentCategoryDataGrid } from '../components/documentCategoryDataGrid';

export const DocumentCategoryOverviewPage = () => {
  const { t } = useTranslation();

  const [openDocumentCategoryHandler, setOpenDocumentCategoryHandler] = useState<boolean>(false);
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [refetchDataGrid, setRefetchDataGrid] = useState<boolean>(false);
  const [documentCategorySearchFilter, setDocumentCategorySearchFilter] = useState<DocumentCategorySearchFilter>({
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    sortCol: 'category',
    sortDir: 'desc',
    filter: '',
  });

  const pageTabs: PageTabItem[] = [
    {
      label: t('documentArchive:files'),
      route: RoutesEnum.DocumentArchiveOverview,
    },
    {
      label: t('documentArchive:categories'),
      route: RoutesEnum.DocumentCategoryOverview,
    },
  ];

  return (
    <>
      <GridWrapper>
        <Grid
          item
          xs={6}
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <MainContentHeader title={t('documentArchive:documentArchive')} />
        </Grid>

        <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() => setOpenDocumentCategoryHandler(true)}
            variant='contained'
            color='primary'
            startIcon={<Add fontSize='small' />}
            disableElevation
          >
            {t('documentArchive:createCategory')}
          </Button>
        </Grid>

        <Grid item xs={12}>
          <Paper>
            <PageTabNavigation pageTabs={pageTabs} />
            <Box className='section-inset'>
              <DocumentCategoryDataGrid
                refetchDataGrid={refetchDataGrid}
                setRefetchDataGrid={setRefetchDataGrid}
                setCategoryId={setCategoryId}
                setOpenEditCategory={setOpenDocumentCategoryHandler}
                searchFilter={documentCategorySearchFilter}
                searchFilterCallback={(newFilter) =>
                  setDocumentCategorySearchFilter((prev) => ({
                    ...prev,
                    ...newFilter,
                  }))
                }
              />
            </Box>
          </Paper>
        </Grid>
      </GridWrapper>

      <DocumentCategoryHandler
        key={categoryId}
        openModal={openDocumentCategoryHandler}
        setOpenModal={setOpenDocumentCategoryHandler}
        setRefetchDataGrid={setRefetchDataGrid}
        documentCategoryId={categoryId ?? null}
        setDocumentCategoryId={setCategoryId}
      />
    </>
  );
};
